import React from "react";

export default function EpisodesSection() {
  return (
    <section
      className="bg-dustyrose flex flex-col items-center justify-center px-6 sm:px-10 py-10 sm:py-[52px]"
      style={{
        zIndex: 20,
        minHeight: "32vh",
        position: "relative",
      }}
    >
      <p
        className="font-montserrat"
        style={{
          fontSize: "16px",
          fontWeight: 600,
          letterSpacing: "0.26em",
          color: "#571310",
          textTransform: "uppercase",
          marginBottom: "6px",
          marginTop: 0,
        }}
      >
        NEW EPISODES EVERY
      </p>
      <p
        className="font-script"
        style={{
          fontSize: "clamp(88px, 9vw, 150px)",
          fontWeight: 700,
          color: "#571310",
          lineHeight: 1.05,
          margin: 0,
          transformOrigin: "center",
        }}
      >
        monday
      </p>
    </section>
  );
}
